import { useState } from "react";
import { useQuery } from "react-query";
import { Button, Card, Collapse } from "reactstrap";
import { useParams, Link } from "react-router-dom";
import apiService from "services/api";
import { FiEdit, FiChevronsDown, FiChevronsUp } from "react-icons/fi";
import { Bordered } from "components";
import { Accordion, HorizontalLine } from "./components";
import { BorderedBoxEntry } from "pages/LessonRecord/components";
import { lessonCategories } from "./constants";
import { capitalize } from "utils/capitalize";
import { models, permission, permissionCheck } from "utils/permissionCheck";

const ViewCoursePage = () => {
	const { course_id } = useParams();
	const { data: course, isLoading } = useQuery(["course", course_id], () =>
		apiService.course.get(course_id).then((course) => ({
			...course,
			lessons: course?.lessons.map((lesson, index) => ({
				...lesson,
				index,
			})),
		}))
	);

	const [openCategories, setOpenCategories] = useState([]);

	const lessonsByCategories = lessonCategories.map((category) => ({
		category,
		lessons: course?.lessons.filter((lesson) => category === lesson.category),
	}));

	const toggleCollapse = (category) => {
		if (openCategories.includes(category)) return setOpenCategories((categories) => categories.filter((cat) => cat !== category));
		return setOpenCategories((categories) => [...categories, category]);
	};

	return (
		<div className="content">
			{isLoading ? (
				<h1 className="text-center">Loading</h1>
			) : (
				<>
					<div className="container">
						<div className="d-flex mb-2 justify-content-between">
							<Link to="/course">
								<Button color="info" size="sm" className="text-white d-flex align-items-center border border-info" type="button">
									&lt; Back
								</Button>
							</Link>
							{permissionCheck(apiService.auth.token.get(), models.COURSE, permission.UPDATE) ? (
								<Link to={`/course/edit/${course_id}`}>
									<Button color="warning" size="sm" className="text-white d-flex align-items-center border border-warning" type="button">
										<FiEdit /> <span className="ml-2">Edit</span>
									</Button>
								</Link>
							) : (
								<span></span>
							)}
						</div>

						<h4 className="text-center text-secondary mb-4 font-weight-bold my-3">View Course</h4>

						<Bordered.Box className="mb-5">
							<BorderedBoxEntry label="Course Name" value={course.name} />
							<BorderedBoxEntry label="Course Price" value={course.price} />
						</Bordered.Box>

						<h4 className="text-center text-secondary pt-5 mb-4 font-weight-bold">Lessons</h4>

						{lessonsByCategories.map(({ lessons, category }) => (
							<div
								key={category}
								className="col-12 py-2 mb-5"
								style={{
									border: "2px solid #ffffff25",
									borderRadius: 8,
									backgroundColor: "#1D253B",
									cursor: "pointer",
								}}
								id="accordion"
								role="tablist"
							>
								<div
									className="d-flex justify-content-between align-items-center mb-2"
									aria-expanded={openCategories.includes(category)}
									data-parent="#accordion"
									data-toggle="collapse"
									onClick={() => {
										if (lessons.length) toggleCollapse(category);
									}}
								>
									<div className="display-6 font-weight-bold text-white">{capitalize(category)}</div>
								</div>
								<HorizontalLine />
								{lessons.length ? (
									lessons.map((lesson, i, self) => (
										<div key={lesson.id} className="my-1">
											<Collapse isOpen={openCategories.includes(category)} onClick={(e) => e.stopPropagation()}>
												<Accordion header={`Lesson ${i + 1} - ${lesson.name}`}>
													{lesson.learningObjectives.map((learningObj, j) => (
														<div className="row text-light my-1" key={j}>
															<div className="col ml-4">
																{`LO${j + 1} -`}
																<span className="ml-1">{learningObj.name}</span>
															</div>
														</div>
													))}
												</Accordion>
											</Collapse>
										</div>
									))
								) : (
									<div className="text-center text-muted mt-3 mb-1">No Lessons Yet</div>
								)}
								{Boolean(lessons.length) && (
									<div
										className="text-center text-muted mt-3 mb-1"
										onClick={() => {
											if (lessons.length) toggleCollapse(category);
										}}
									>
										{!openCategories.includes(category) ? <FiChevronsDown style={{ fontSize: 28 }} /> : <FiChevronsUp style={{ fontSize: 28 }} />}
									</div>
								)}
							</div>
						))}
					</div>
				</>
			)}
		</div>
	);
};

export default ViewCoursePage;
